// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pMRh","footer":"styles_footer__2Qs1p","passCodeTooltip":"styles_passCodeTooltip__2FdDp"};